import { isEmpty } from 'lodash';
export var isDefined = obj => {
  if (!obj && obj !== 0) {
    return false;
  }
  return true;
};
export var areEmpty = values => values.every(value => isEmpty(value));
export var isA = (value, name) => value && typeof value["is".concat(name)] === 'function' && value["is".concat(name)]();